import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './filterChip.module.scss';
import { Typography } from '@mui/material';
export function FilterChip({ label, value }) {
    return (_jsx("div", { className: styles.chipContainer, children: _jsxs(Typography, { className: styles.text, children: [label, ": ", _jsx("span", { className: styles.value, children: value })] }) }));
}
